// AL1.2 — ASK LALA'S OPENING COPY, MOVED OUT OF App.tsx BY R43.
//
// The greeting, the intro line and the pool the empty thread's chips are drawn from. It is DATA and
// it left for R37's reason: move the data, not the component. `AskLalaPage` holds a dozen hooks and
// stays; this table is now loadable and callable by a gate, which it never was inside the monolith.
//
// THE SECOND LINE IS THE OWNER'S EXACT GREETING. It used to be a random pool of one-liners; she
// specified these two lines, so they are FIXED and each renders on its own line. Only the CHIPS are
// sampled (`pickSome`, five of the seven), and they are prompts, not greetings.
export const ASK_LALA_INTRO = "I am Lala Inuti Ahari. Ask me anything, your chart, your numerology, your readings, your people, your path.";

// AL1.2: the owner's exact greeting. It was a random pool of one-liners; she specified these
// two lines, so they are fixed and each renders on its own line.
export const ASK_LALA_GREETING_LINE_2 = "What are we manifesting today?";

export const ASK_LALA_CHIP_POOL = [
  "I need a spell for a situation",
  "Explain my astrology report",
  "I have questions about compatibility",
  "Ask about a Conjure product",
  "I need spiritual advice",
  "What does my numerology mean?",
  "Help me understand my tarot reading",
];
